// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"6a44abcc","732":"9731b038","977":"444553d3"}[chunkId] + ".chunk.js";
};